// extracted by mini-css-extract-plugin
module.exports = {"module":"Module-module__module___2IYz6"};